import React from "react"
import { connect } from "react-redux";
import { Marker, LayerGroup } from "react-leaflet";
import _ from "lodash";
import { createCustomIcon } from "./Icons";
import { selectMarker, routeSelected } from "redux/actions/index";
import { LazyMapTooltip } from "components/util/LazyTooltips";
import { MEMOIZED_DOMAIN_URL } from "../util/HostUtils";
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { filterSessionObservations } from "../util/PlaylistUtils";

class ObservationMarkers extends React.PureComponent {

    selectObservation(id) {
        const selectedObservation = _.find(this.props.filteredObservations, {id: id})

        this.props.dispatch(selectMarker(selectedObservation, true))
        this.props.dispatch(routeSelected(this.props.sessionID, selectedObservation.video_key, undefined, undefined, undefined, selectedObservation.frame))
    }

    createTooltip(observation) {
        let session = this.props.sessions[this.props.sessionID];
        if (observation.video_key && session) {
            let enhancedImgSrc = `https://raw${MEMOIZED_DOMAIN_URL}/${session.device_uuid}/${session.uuid}/${observation.video_key}-${observation.frame}.jpg`
            if(this.props.csrfToken){
                enhancedImgSrc += `?csrf=${this.props.csrfToken}`
            }
            let image = null;
            if (observation.frame >= 0) {
                image = <img src={enhancedImgSrc}
                             className="MarkerToolTipImage" alt="Observation Thumbnail"
                             crossOrigin={"anonymous"}/>
            }
            return (
                <div className={"MarkerTooltipOuter"}>
                    {_.get(observation, "class", "") ? <div>{_.get(observation, "class", "")}</div> : null}
                    {image}
                </div>
            );
        }
        return null;
    }
    
    renderObservationMarkers = () => {
        if (this.props.filteredObservations.length < 1) {
            return null
        }

        let icon = _.get(this.props.filteredObservations[0], "icon_type")
        let iconColor = _.get(this.props.filteredObservations[0], "icon_colour")
        let markerIcon = createCustomIcon(icon, iconColor, false);

        // in case markerIcon is not being rendered display default (exclamation-triangle)
        if (!_.get(markerIcon, ["options", "html"] , "").length) {
            markerIcon = createCustomIcon("exclamation-triangle", null, false);
        }

        let uniqueObservations = filterSessionObservations(this.props.filteredObservations, this.props.observationFilters)
        uniqueObservations = _.uniqBy(_.sortBy(uniqueObservations, ["observation_number", "id"]), "observation_number")
        
        return uniqueObservations.map(obs => {
            const tooltip = this.createTooltip(obs);

            return (
                <Marker
                    key={obs.id}
                    position={[obs.coords[1], obs.coords[0]]}
                    icon={markerIcon}
                    onClick={() => this.selectObservation(obs.id)}>
                        {tooltip && <LazyMapTooltip className="Incident-Tooltip" permanent={false} interactive={true} direction={"top"} offset={[0, -30]}>
                            {tooltip}
                        </LazyMapTooltip>}
                </Marker>
            );
        });
    }

    render() {
        return (
            <LayerGroup>
                <MarkerClusterGroup maxClusterRadius={32} showCoverageOnHover={false} animate={true} zoomToBoundsOnClick={true} >
                    {this.renderObservationMarkers()}
                </MarkerClusterGroup>                
            </LayerGroup>
        );
    }
}

const mapStateToProps = (state) => {
    const filteredObservations = _.filter(state.sessionObservations, obs => obs.class === state.markers.selectedMarker?.class && state.markerReviewFilters.includes(obs.review_status));

    return {
        filteredObservations,
        sessionID: state.playlist.data.routeID,
        sessions: state.sessions,
        mapZoom: state.sessionFilters.mapBounds.zoom,
        displayObservationMarkers: state.displayObservationMarkers,
        observationFilters: state.observationFilters,
        csrfToken: state.csrfToken
    }
};

export default connect(mapStateToProps)(ObservationMarkers);
